import { SxProps, Theme } from '@mui/material'

export const registeredLeadFeedbackWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  alignItems: 'center',
  justifyContent: 'center',
  gap: {
    xs: '1.6rem',
    md: '3.2rem',
  },
}

export const checkIconWrapperSx: SxProps<Theme> = {
  background: (theme) => theme.palette.background.paper,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const checkIconSx: SxProps<Theme> = {
  fontSize: {
    xs: '12rem',
    md: '16rem',
  },
  color: (theme) => theme.palette.secondary.main,
}

export const textWrapperSx: SxProps<Theme> = {
  display: 'flex',
  gap: '1.6rem',
  flexDirection: 'column',
  width: {
    xs: '100%',
    lg: '80rem',
  },
}

export const textSx: SxProps<Theme> = {
  textAlign: {
    xs: 'center',
    md: 'left',
  },
  color: (theme) => theme.palette.background.paper,
}

export const buttonWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: { lg: 'center' },
  flexDirection: { xs: 'column', lg: 'row' },
  gap: { xs: '1.2rem', lg: '1.6rem' },
}

export const buttonSx: SxProps<Theme> = {
  letterSpacing: '0.125rem',
  order: { xs: 1, lg: 3 },
}
